import { cn } from '../lib/utils';

type VersionLabelProps = {
  className?: string;
};

const VersionLabel = ({ className }: VersionLabelProps) => {
  const gitSha = (
    import.meta.env.REACT_APP_GIT_SHA || process.env.CF_PAGES_COMMIT_SHA
  )?.slice(0, 6);

  return (
    <div className={cn('text-xs text-center', className)}>
      v{import.meta.env.REACT_APP_VERSION || '1.0.0-'}
      {gitSha}
    </div>
  );
};

export default VersionLabel;
